import { render, staticRenderFns } from "./index.vue?vue&type=template&id=694fe2bc&scoped=true&lang=pug&"
var script = {}
import style0 from "./photo-report.scss?vue&type=style&index=0&id=694fe2bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694fe2bc",
  null
  
)

export default component.exports